/**
 * Internal dependencies
 */
import './align';
import './anchor';
import './custom-class-name';
import './generated-class-name';
import './style';
import './color';
import './font-size';
import './border-color';
import './layout';

export { getColorClassesAndStyles, useColorProps } from './use-color-props';
